import type { FC } from "react";
import { WhatToCountCategoryRow } from "web_myplann/Finances/Components/WhatToCountCategoryRow";
import type { FinancesWhatToCount } from "web_myplann/Infrastructure/Translations/ResourceDictionary";

type Props = {
	categories: FinancesWhatToCount["categories"];
};

export const WhatToCountCategoryList: FC<Props> = ({ categories }) => (
	<>
		{categories.map((category) => (
			<WhatToCountCategoryRow key={category.title} category={category} />
		))}
	</>
);
